var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_view_container"},[(
            _vm.App.root_activated_view !==
            'single_application_solution'
        )?_c('section',{staticClass:"lateral_block"},[_c('comp_lateral_menu')],1):_vm._e(),_c('section',{staticClass:"main_block"},[_c('comp_menu_lang'),_c('div',{attrs:{"clasS":"main_block_container"}},[_c('view_app_selector',{attrs:{"activated_view":"dashboard"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }